export function NotFound() {
  return <h1
  style={{color: "red", textAlign: "center"}}
  >404</h1>;
}